import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
export function Gallery() {
  // Using high-quality unsplash placeholders that fit the aesthetic
  const images = ['https://cdn.magicpatterns.com/uploads/t9wxPqfKCXK5TTRYLjAMnx/Beignets_2B_Carats__Bridal_Shower_Inspiration___Munaluchi_Bride_(1).jpg', 'https://cdn.magicpatterns.com/uploads/gmuFrCoGfMW99Tst5W77bc/1.png', 'https://cdn.magicpatterns.com/uploads/fwD5GWmLnUjSQttDUBwDMy/2.png', 'https://cdn.magicpatterns.com/uploads/t9wxPqfKCXK5TTRYLjAMnx/Beignets_2B_Carats__Bridal_Shower_Inspiration___Munaluchi_Bride_(1).jpg', 'https://cdn.magicpatterns.com/uploads/gmuFrCoGfMW99Tst5W77bc/1.png', 'https://cdn.magicpatterns.com/uploads/fwD5GWmLnUjSQttDUBwDMy/2.png'];
  // Duplicate for seamless infinite scroll
  const duplicatedImages = [...images, ...images];
  return <section className="py-24 bg-cream overflow-hidden" data-id="element-98">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-12" data-id="element-99">
        <FadeIn data-id="element-100">
          <h2 className="text-4xl md:text-5xl font-bold text-center" data-id="element-101">
            What We're Building
          </h2>
          <p className="text-center text-body mt-4 text-lg" data-id="element-102">
            A look inside our events, workshops, and community gatherings.
          </p>
        </FadeIn>
      </div>

      <div className="relative w-full flex overflow-hidden" data-id="element-103">
        {/* Left/Right gradient masks for smooth fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-r from-cream to-transparent z-10 pointer-events-none" data-id="element-104"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-l from-cream to-transparent z-10 pointer-events-none" data-id="element-105"></div>

        <div className="flex w-[200%] animate-marquee" data-id="element-106">
          {duplicatedImages.map((src, index) => <div key={index} className="w-1/3 md:w-1/4 lg:w-1/5 flex-shrink-0 px-3" data-id="element-107">
              <div className="aspect-[4/5] rounded-xl overflow-hidden shadow-md border border-cream-dark group" data-id="element-108">
                <img src={src} alt="Community highlight" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-109" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}